/**
 * Browser configuration. Vite reads these from the repo-root `.env.local` that `neon deploy` /
 * `neon env pull` writes (see `envDir` / `envPrefix` in vite.config.ts), so no values are copied
 * by hand. Only public URLs are exposed — never DATABASE_URL or storage credentials.
 */
export const env = {
  /** Neon Auth URL. The browser reaches it through the Worker's /api/auth proxy; this only marks auth as configured. */
  authUrl: (import.meta.env.NEON_AUTH_BASE_URL as string | undefined)?.trim() ?? '',
  dataApiUrl: (import.meta.env.NEON_DATA_API_URL as string | undefined)?.trim() ?? '',
  apiBase: ((import.meta.env.VITE_API_BASE as string | undefined)?.trim() ?? '').replace(/\/$/, ''),
};

/** False when no Neon backend is configured: tools and the bundled reference formulary still work. */
export const isBackendConfigured = env.authUrl.startsWith('https://') && env.dataApiUrl.startsWith('https://');

export const APP_NAME = 'EMS Atlas';
